export const API_ERROR_MESSAGES = {
  NOT_FOUND: "No found",
  UNEXPECTED_ERROR: "Unexpected error"
}
